import React, { useState, useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';

import Pagination from '../../../../Pagination';
import BillPaymentsTable from '../../../../BillPaymentsTable';

import LenderService from '../../../../../services/LenderService';

export default function BillPayments({ lenderId }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);

  const { data: distributions, isFetching } = useQuery({
    queryKey: ['lenderBillPayments', lenderId],
    queryFn: () =>
      LenderService.getLenderBillPayments({
        lenderId,
        page: 1,
        limit: 10,
      }),
  });

  useEffect(() => {
    if (distributions) {
      setPageTotal(distributions.pageTotal);
      //  previousData.current = distributions;
    }
  }, [distributions]);

  const switchToPage = (selected) => {
    const page = selected.selected + 1;
    if (page < 1 || page > pageTotal) {
      return;
    }

    setCurrentPage(page);
  };

  return (
    <div className="p-7 pb-0 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6 flex justify-between w-full">
        Bill Payments
      </h2>
      <BillPaymentsTable
        isFetching={isFetching}
        billPayments={distributions?.items}
        noTitle
        isLenderPage
      />
      <Pagination
        noTitle
        pageTotal={pageTotal}
        switchToPage={switchToPage}
        currentPage={currentPage}
      />
    </div>
  );
}
